import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
  TRANSLOCO_TRANSPILER,
  FunctionalTranspiler
} from '@ngneat/transloco';
import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import en from './assets/i18n/en';
import enGb from './assets/i18n/en-gb';
import es from './assets/i18n/es';
import fr from './assets/i18n/fr';
import nl from './assets/i18n/nl';
import de from './assets/i18n/de';
import { Observable, of } from 'rxjs';
import { PhxTranslationService } from './translation.service';
import { TranslatePluralPipe } from './translation-plural.pipe';
import { PhxTranslatePipe } from './phx-translation.pipe';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    if (lang === 'en') {
      return of(en);
    } else if (lang === 'en-GB') {
      return of(enGb);
    } else if (lang === 'fr') {
      return of(fr);
    } else if (lang === 'es') {
      return of(es);
    } else if (lang === 'nl') {
      return of(nl);
    } else if (lang === 'de') {
      return of(de);
    } else {
      return of(en); // default case
    }
  }
}

@NgModule({
  imports: [TranslocoModule],
  exports: [ TranslocoModule, TranslatePluralPipe, PhxTranslatePipe ],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en', 'en-GB', 'es', 'fr', 'nl', 'de'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    { provide: TRANSLOCO_TRANSPILER, useClass: FunctionalTranspiler },
  ],
  declarations: [TranslatePluralPipe, PhxTranslatePipe],
})
export class PhxTranslationsRootModule {
  static forRoot(): ModuleWithProviders<PhxTranslationsRootModule> {
    return {
      ngModule: PhxTranslationsRootModule,
      providers: [PhxTranslationService]
    };
  }
}
